<script>
        import { fade } from "svelte/transition";
</script>

<div class="row" style="margin-top: 15%; margin-bottom: 5%;" in:fade>
    <div class="twelve columns" style="margin-bottom: 10%;">
        <h3>404 not found.</h3>
        <a href="https://planning-poker-live.herokuapp.com" style="font-size: 15px">Back to the main menu</a>
        <span ></span>        
    </div>
</div>